<script>
  import ArtWorksCard from "./overlay-drawer-artworks-card.vue";
  export default {
    components: {
      ArtWorksCard,
    },
    props: {
      artworks: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<template>
  <section>
    <h2
      class="
      $color/gray:767
      $typography/size:medium
      color
      layout/padding:left:page
      layout/padding:right:page
      typography
    "
    >
      Artworks on view
    </h2>
    <ul
      class="
        @600/layout/padding:bottom:cap:2
        layout/flex
        layout/grid:gap:column:page:0.5
        layout/margin:top:page
        layout/padding:bottom:cap
        layout/padding:left:page
        layout/padding:right:page
        layout/scroll:horizontal
        width:100%
      "
      >
      <ArtWorksCard
        v-for="artwork in artworks"
        :key="artwork.Id"
        :artwork="artwork"
      />
    </ul>
  </section>
</template>